import React from "react";
import Button from "../components/Button";

const ModalSure = (props) => {
  return (
    <div className="d-flex justify-center align-items-center direction-column gap-1">
      {props.text ? props.text : <p>Вы уверены?</p>}
      <div className="buttons d-flex gap-1">
        <Button
          onClick={() => {
            props.onSure && props.onSure(true);
            props.onClose && props.onClose();
          }}
        >
          Да
        </Button>
        <Button
          className="background-dark border-dark"
          onClick={() => props.onClose()}
        >
          Назад
        </Button>
      </div>
    </div>
  );
};

export default ModalSure;
